import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/shared/services/common.service';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageEventServiceService } from 'src/app/shared/services/local-storage-event-service.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

interface Product {
  name?: string;
  id?:any;
}
interface ProductMeta {
  id?: string;
  status?: string;
  dibd?: string | null; // DIBD
  ibd?: string | null; // IBD
  safetyTitle?: string;
  safetyStrategyLink?: string;
  producttype?: string;
  productName?: string;
}
interface FieldConfig {
  key: string;
  label: string;
  type: "text" | "select" | "multiselect" | "date";
  options?: string[];
  lookupType?: string;
}

interface ActiveFilter {
  key: string;
  label: string;
  value: any;
}
@Component({
    selector: 'app-jsip-left-pannel',
    templateUrl: './jsip-left-pannel.component.html',
    styleUrls: ['./jsip-left-pannel.component.scss'],
    standalone: false
})
export class JsipLeftPannelComponent implements OnInit {
 @Output() sidenavToggle = new EventEmitter<boolean>();

  advancedForm!: FormGroup;
  searchForm!: FormGroup;


  backgroundColorButton;
  isSidenavOpen = true;
  productsDisplayed = [
    
  ];
  products = [];
  productsFiltered = [];
  selectedProduct: any = null; 
  productMeta?: ProductMeta;
  advancedSchema: FieldConfig[] = [];
  activeFilters: ActiveFilter[] = [];
  advancedFilters: ActiveFilter[] = [];

  productSearchText: string = "";

   schema: FieldConfig[] = [
    {
      key: "status",
      label: "Regulatory Status",
      type: "select",
      lookupType: "RegulatoryStatus",
    },
    { key: "ibd", label: "IBD Date", type: "date" },
    { key: "genericName", label: "Generic Name", type: "text" },
    {
      key: "producttype",
      label: "Product Type",
      type: "select",
      lookupType: "ProductType",
    },
  ];

  allPossibleFields: FieldConfig[] = [
    ...this.schema,

    // Therapy Info
    {
      key: "moleculeType",
      label: "Molecule Type",
      type: "multiselect",
      options: ["Small Molecules", "Large Molecules", "Biosimilars", "ATMPs"],
    },
    {
      key: "therapeuticCategory",
      label: "Therapeutic Category",
      type: "multiselect",
      options: [
        "Cardiovascular",
        "CNS",
        "Oncology",
        "Endocrinology",
        "Infections Diseases",
        "Respiratory",
        "Gastrointestinal",
        "Immunology & Rheumatology",
        "Hematology",
        "Dermatology",
      ],
    },
    { key: "ibd", label: "IBD", type: "date" },
    { key: "dibd", label: "DIBD", type: "date" },
    { key: "indications", label: "Indications", type: "text" },
    { key: "indicationDesc", label: "Indication Desc", type: "text" },

    // Administration
    { key: "dosageForm", label: "Dosage Form", type: "text" },
    { key: "routeOfAdmin", label: "Route of Admin", type: "text" },
    {
      key: "approvalCountries",
      label: "Approval Countries",
      type: "multiselect",
      options: ["US", "EU", "India", "Japan"],
    }, // update as needed
    { key: "expectedAE", label: "Expected AE List", type: "text" },
    { key: "specialPops", label: "Special Populations", type: "text" },
    { key: "imeList", label: "IME List", type: "text" },
    {
      key: "contraWarnings",
      label: "Contraindication & Warnings",
      type: "text",
    },

    // Literature Info
    { key: "sameinClass", label: "Samein Class", type: "text" },
    {
      key: "modeOfAction",
      label: "Mode of Action",
      type: "select",
      options: ["Gene Therapy", "Cell Therapy"],
    },
    {
      key: "inclusionExclusion",
      label: "Inclusion/Exclusion",
      type: "select",
      options: ["Inclusion", "Exclusion"],
    },
    { key: "reason", label: "Reason", type: "text" },

    // Governance
    {
      key: "dataSourceNames",
      label: "Data Source Names",
      type: "multiselect",
      options: ["Company Safety Data (LSMV, ARGUS)", "FAERS", "EVDAS"],
    },
    { key: "group", label: "Group", type: "text" },
    {
      key: "productLead",
      label: "Product Lead",
      type: "multiselect",
      options: [],
    }, // populate dynamically if needed
    {
      key: "deputyProductLead",
      label: "Deputy Product Lead",
      type: "multiselect",
      options: [],
    },
    { key: "groupHead", label: "Group Head", type: "multiselect", options: [] },
    {
      key: "deputyGroupHead",
      label: "Deputy Group Head",
      type: "multiselect",
      options: [],
    },

    // Device Info
    { key: "udi", label: "UDI", type: "text" },
    { key: "deviceIdentifier", label: "Device Identifier", type: "text" },
    { key: "gmdnCode", label: "GMDN Code", type: "text" },
    { key: "umdcCode", label: "UMDC Code", type: "text" },
    {
      key: "riskClass",
      label: "Risk Class",
      type: "select",
      options: ["Class I", "IIa", "IId", "III (EU MDR)", "I, II, III (FDA)"],
    },
    {
      key: "productCategory",
      label: "Product Category",
      type: "select",
      options: ["Implant", "Diagnostic", "SaMD", "IVD"],
    },
  ];
  constructor(
    private localStorage: LocalStorageSettingsService,
    private jsignalsService: JsignalService,
    private fb: FormBuilder,
    private commonService: CommonService,
    private storeEvents:LocalStorageEventServiceService
  ) { }

  ngOnInit(): void {
    this.advancedForm = this.fb.group({});
     const group: any = {};
    this.schema.forEach((field) => {
      group[field.key] = field.type === "multiselect" ? [[]] : [""];
    });
     this.searchForm = this.fb.group(group);
     //fetch product name

      this.loadDynamicOptions(this.allPossibleFields);

    /**
   * @author Rahul Vk
   * @Date 14-11-2025
   * @Desc fetch the list of product[{id:,name:}]
   */   
  this.jsignalsService.getProductList().subscribe({
  next: (response: any[]) => {
    try {
      // Validate response type before mapping
      if (!Array.isArray(response)) {
        throw new Error('Invalid response type: expected an array.');
      }

      // Map both id and name safely
      this.products = response.map((item, index) => {
        if (!item || typeof item !== 'object') {
          throw new Error(`Invalid item at index ${index}: ${JSON.stringify(item)}`);
        }

        return {
          id: item.id,
          name: item.name
        } as Product;
      });
      // Initialize your displayed & selected arrays
      this.productsDisplayed = [{ id: null, name: 'None' } as Product,...this.products];
      // this.selectedProduct = this.products[0] || null;

      // if (this.selectedProduct) {
      //   this.loadMeta(this.selectedProduct.name!);
      // }
    } catch (error) {
      console.error(' Error while processing product list:', error);
      
    }
  },
  error: (err) => {
    console.error(' API Error while fetching product list:', err);
  },
});
     this.backgroundColorButton = this.localStorage.getSettings("ColorA");
  }

    toggleSidenav() {
    this.isSidenavOpen = !this.isSidenavOpen;
    console.log(this.isSidenavOpen);
    
    // Allow DOM to update first before measuring scroll dimensions
    // setTimeout(() => {
    //   this.updateArrowVisibility();
    //   this.checkTopArrowVisibility();
    // }, 200); // Adjust timing if needed
    this.sidenavToggle.emit(this.isSidenavOpen);
  }
   loadMeta(name: string) {
    this.productMeta = undefined; // clear old
    this.jsignalsService.getProductMetadata(name).subscribe((arr) => {
      const raw = arr.length ? arr[0] : {};
      this.productMeta = this.mapToMeta(raw);
      this.storeEvents.setSelectedProduct(this.productMeta)
    });
  }

   private mapToMeta(raw: any): ProductMeta {
    const clean = (v: any): string | null =>
      v == null || (typeof v === "string" && !v.trim()) ? null : v;
    const productName = clean(raw.product__v_name__v) || "";
    return {
      id: clean(raw.id),
      status: clean(raw.status__v),
      dibd: clean(raw.registration_date__v),
      ibd: clean(raw.international_birthdate__v),
      safetyTitle: productName ? `${productName} Safety Strategy` : null,
      // safetyStrategyLink:  clean(raw.link__sys),
      producttype: clean(raw.object_type__v_name__v),
      productName:productName
    };
  }

   onProductSelected(prod: Product) {
    this.selectedProduct = prod;
    if(this.selectedProduct.name!='None'){ 
      console.log(this.selectedProduct);
      this.loadMeta(prod.name!);
    }else{
      this.storeEvents.setSelectedProduct(null)
    }
   
  }

  addAdvancedField(field: FieldConfig) {
    // prevent duplicates
    if (this.advancedSchema.find((f) => f.key === field.key)) return;

    this.advancedSchema.push(field);
    // add control (empty initial value)
    this.advancedForm.addControl(
      field.key,
      this.fb.control(field.type === "multiselect" ? [] : "")
    );
  }
   getAdvancedFieldByKey(key: string) {
    return this.advancedSchema.find((f) => f.key === key);
  }

   removeAdvancedField(key: string) {
    this.advancedSchema = this.advancedSchema.filter((f) => f.key !== key);
    this.advancedForm.removeControl(key);

    this.productsFiltered = [...this.products]; // restore from original

    this.applyAllFilters();
  }

  applyAdvancedFilters() {
    this.applyAllFilters();

    this.selectedProduct = this.productsFiltered[0] || null;
  }

   clearAllAdvancedFilters(): void {
    this.advancedSchema = [];
    this.advancedForm.reset();
    this.advancedFilters = [];
    this.productsFiltered = [...this.products];
    this.applyAllFilters();

    if (!this.productsFiltered.includes(this.selectedProduct)) {
      this.selectedProduct = this.productsFiltered[0] || null;
    }
  }

isArray(value: any): boolean {
    return Array.isArray(value);
  }
 getFieldType(key: string): string {
    const field = this.schema.find((f) => f.key === key);
    return field ? field.type : "";
  }

  private compareDateField(
    productDate: string | Date,
    filterDate: Date
  ): boolean {
    const d1 = this.normalizeDate(productDate);
    const d2 = this.normalizeDate(filterDate);

    console.log(d1, d2);

    if (!d1 || !d2) return false;

    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }

  private normalizeDate(input: any): Date | null {
    // Handle native Date
    if (input instanceof Date && !isNaN(input.getTime())) {
      return new Date(input.getFullYear(), input.getMonth(), input.getDate());
    }

    // Handle Moment.js
    if (input && input._isAMomentObject && input.isValid()) {
      return new Date(input.year(), input.month(), input.date());
    }

    // Handle dd/mm/yyyy strings
    if (typeof input === "string") {
      const parts = input.trim().split("/");
      if (parts.length === 3) {
        const [day, month, year] = parts.map(Number);
        if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
          return new Date(year, month - 1, day);
        }
      }

      // Handle ISO yyyy-mm-dd strings
      const isoMatch = input.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (isoMatch) {
        const [_, y, m, d] = isoMatch;
        return new Date(+y, +m - 1, +d);
      }
    }

    return null;
  }

  applyAllFilters() {
    const searchValues = this.searchForm.value;
    const advancedValues = this.advancedForm.value;

    // Combine both filter sets
    this.activeFilters = this.schema
      .filter((f) => {
        const v = searchValues[f.key];
        return Array.isArray(v) ? v.length > 0 : !!v;
      })
      .map((f) => ({
        key: f.key,
        label: f.label,
        value: searchValues[f.key],
      }));

    this.advancedFilters = this.advancedSchema
      .filter((f) => {
        const v = advancedValues[f.key];
        return Array.isArray(v) ? v.length > 0 : !!v;
      })
      .map((f) => ({
        key: f.key,
        label: f.label,
        value: advancedValues[f.key],
      }));

    const allFilters = [...this.activeFilters, ...this.advancedFilters];

    this.productsFiltered = this.products.filter((p) =>
      allFilters.every((f) => {
        const val = (p as any)[f.key];
        if (Array.isArray(f.value)) return f.value.includes(val);
        if (this.getFieldType(f.key) === "date")
          return this.compareDateField(val, f.value);
        return String(val).toLowerCase() === String(f.value).toLowerCase();
      })
    );

    // Refresh dropdown search based on new filter result
    this.filterProducts();

    if (!this.productsFiltered.includes(this.selectedProduct)) {
      this.selectedProduct = this.productsFiltered[0] || null;
    }
  }

    filterProducts() {
    const search = this.productSearchText.toLowerCase().trim();

    const sourceList =
      this.activeFilters.length > 0 || this.advancedFilters.length > 0
        ? this.productsFiltered
        : this.products;

    this.productsDisplayed = sourceList.filter((product) =>
      (product.name || "").toLowerCase().includes(search)
    );
  }

  loadDynamicOptions(fields: FieldConfig[]) {
    fields.forEach((field) => {
      if (field.lookupType) {
        this.commonService
          .getlookupVauleByLookUpType(field.lookupType)
          .subscribe((res: any) => {
            const values = res as any[];
            field.options = values.map((v) => v.lookupvalue);
          });
      }
    });
  }

}
